import { css } from 'styled-system/css';

export const timeMachineStyles = {
	question: css({
		_mars: {
			marginTop: '-12px',
			marginBottom: '-12px',
			bottom: '-6px',
			zIndex: '1',
			'& .btn--icon': {
				color: 'black.3',
			},
			'& .tip--detail': {
				backgroundColor: 'var(--s800)',
			},
			'&[data-open="true"]': {
				'& .btn--icon': {
					color: 'black.1',
				},
			}
		}
	}),
	timeMachine: css({
		_mars: {
			_before: {
				content: '""',
				display: 'block',
				backgroundColor: 'var(--time-machine-bg)',
				backgroundImage: 'radial-gradient(ellipse at center, token(colors.timeMachine.clock.gradient1) 10%, token(colors.timeMachine.clock.gradient2) 60%)',
				backgroundRepeat: 'no-repeat',
				backgroundPositionY: '-50px',
				position: 'absolute',
				left: '0',
				right: '0',
				top: '100px',
				bottom: '0',
				zIndex: '1',
			},
			'& .tm-bettype': {
				marginBottom: '6px',
			},
			'& .tm-clock__select-time::after': {
				backgroundImage: 'radial-gradient(ellipse at center, token(colors.timeMachine.clock.gradient1) 0%, token(colors.timeMachine.clock.gradient2) 70%)',
			},
			'& .odds-button': {
				fontSize: '12px',
			},
			'& .odds-button__title': {
				color: 'black.2',
				// flex: '1',
				flex: 'none',
				width: 'auto',
			},
			'& .odds-button__goal': {
				fontWeight: '400',
				flex: 'none',
				ml: '6px',
			},
			
			'& .odds-button__odds': {
				flex: 'none',
				mr: 'inherit',
			},
			'& .tm-text-title': {
				color: 'bettypeTitle.text',
				fontStyle: 'normal',
				fontWeight: '500',
			},
			'& .tm-slider .tm-text-title': {
				color: 'white',
			},
			'& .tm-slider__bg': {
				bg: 'timeMachine.slider.bg',
			},
			'& .tm-slider__match-time': {
				color: 'white',
				bg: 'timeMachine.slider.bg'
			},
			'& .tm-btn': {
				bg: 'timeMachine.btn.bg',
			},
			'& .tm-slider-group > .tm-btn .tm-icon::before': {
				backgroundColor: 'timeMachine.btn.text',
			},
			// '& .tm-btn-bar .btn': {
			// 	color: 'black.1',
			// 	// background-color: ''
			// }
		},
	}),
	header: css({
		_mars: {
			rounded: '6px 6px 0 0!',
		}
	}),
}